import FirestoreDocument from "../../../types/FirestoreDocument";
import FirestoreLifecycle from "../../../types/FirestoreLifecycle";
import { string } from "../../../types/_types";

import { OrganizationRef } from "../../organizations/types/OrganizationRef";

export const Imprint = FirestoreDocument.extend({
	name: string(3),
	publisher: OrganizationRef,
}).merge(FirestoreLifecycle);
